export class ParametroCarga {

    mensaje: String;
    activo: Boolean;

    constructor(mensaje, activo) {
        this.mensaje = mensaje;
        this.activo = activo;
     }

}


// WEBPACK FOOTER //
// ./src/app/models/spinner/parametroCarga.class.ts